import {gql, useMutation, useReactiveVar} from "@apollo/client";
import {
  CreateTestingFacilityForm,
  Modal,
  CreateTestingFacilityInitialValues,
  CreateTestingFacilityFormSchema,
} from "components";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import { wrapClick } from "utils";
import {currentUserVar} from "../../../apollo/cache/auth";

const CREATE_MATERIAL_STORE = gql`
  mutation CreateMaterialStore(
    $id: ID!
    $materialStore: MeterContactorTestingFacilityInput!
  ) {
    createMeterContractorMaterialStore(
      id: $id
      materialStore: $materialStore
    ) {
      _id
    }
  }
`;

export default function CreateMeterContractorTestingFacilityContainer({
 open,
 setOpen,
 refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {

  const currentUser = useReactiveVar(currentUserVar);
  const [updateTestingFacilities, { loading }] = useMutation(
    CREATE_MATERIAL_STORE
  );

  const form = useFormik({
    initialValues: CreateTestingFacilityInitialValues,
    validationSchema: CreateTestingFacilityFormSchema,
    onSubmit: async (values) => {
      await updateTestingFacilities({
        variables: {
          id: currentUser?.contractor?._id,
          materialStore: values
        },
      }).then(({ data }) => {
        if (data.createMeterContractorMaterialStore?._id) {
          toast(
            JSON.stringify({
              type: "success",
              title: "Material Store Created Successfully",
            })
          );
          refetch?.();
          form.resetForm();
        } else {
          toast(
            JSON.stringify({
              type: "error",
              title: "Could not create Material Store",
            })
          );
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Add New Material Store"
      description="Provide the details to add a new material store"
      size="4xl"
      renderActions={() => (
        <>
          <button
            type="button"
            disabled={loading}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Adding Material Store..." : "Add Material Store"}
          </button>
        </>
      )}
    >
      <CreateTestingFacilityForm form={form} />
    </Modal>
  );
}
